import React from "react";
import DialogForm, { DialogFormPropTypes } from "ui/Dialog";
import PropTypes from "prop-types";
import useExecuteMutation from "hooks/useExecuteMutation";

const ConfirmDialog = (props) => {
  const {
    mutationQueries,
    refetchQueries = [],
    initialValues = {},
    mutationOptions = {},
    onSuccessMessage = null,
    onSuccessCallback = () => {},
    ...otherProps
  } = props;

  const { executeMutation, loading } = useExecuteMutation(mutationQueries, {
    refetchQueries,
    mutationOptions,
    onSuccessMessage,
    onSuccessCallback,
  });

  const handleSubmit = async (data) => {
    await executeMutation(data);
    props.onClose();
  };

  return (
    <DialogForm
      initialValues={initialValues}
      onSubmit={handleSubmit}
      confirmOnDismiss={false}
      isLoading={loading}
      className="confirmation-dialog"
      {...otherProps}
    />
  );
};

const ConfirmDialogPropTypes = {
  ...DialogFormPropTypes,
  mutationQueries: PropTypes.object.isRequired,
  refetchQueries: PropTypes.arrayOf(PropTypes.string),
  mutationOptions: PropTypes.object,
  onSuccessMessage: PropTypes.string,
  onSuccessCallback: PropTypes.func,
  onSubmit: PropTypes.func,
};

delete ConfirmDialogPropTypes.initialValues;
ConfirmDialog.propTypes = ConfirmDialogPropTypes;

export default ConfirmDialog;
